import { Space, Avatar, Button, Modal, Table } from "antd";
import moment from "moment";
import React from "react";
import MasterComponent from "../../components/Forms";
import { MasterConfigs } from "../../interfaces/entity";

const AgreementSigned = () => {
    const [skills, setSkills] = React.useState<any>(null);
    const [pdf, setPDF] = React.useState<any>(null);

    const config: MasterConfigs = {
        api: () => '/v1/vendor',
        title: 'Vendors',
        queryParams: {
            msaSigned: true,
            ndaSigned: true,
        },
        isActionTab: true,
        getColumns: () => [
            {
                title: 'PoC',
                dataIndex: 'pointOfcontact',
                key: 'pointOfcontact',
                render: (text: any) => {
                    return text?.map((item: any) => {
                        return (
                            <Space direction='horizontal' className='contact_info'>
                                <Avatar src={`${process.env.FILE_URL}/files${item.profilePhoto}`} size={30} >
                                    {item.profilePhoto ? '' : item.firstName.split(' ').map((e: string) => e[0]).join('')}
                                </Avatar>
                                <div className="flex flex-col">
                                    <a href={`mailto:${item.email}`} target="_blank" rel="noopener noreferrer">
                                        {item.firstName} {item.lastName}
                                    </a>
                                    <span className="text-gray-400">{item.designation}</span>
                                    <span className="text-gray-400">{item.email}</span>
                                    <span className="text-gray-400">{item.phone}</span>
                                </div>
                            </Space >
                        )
                    })
                },
                width: 200,
                fixed: 'left',
            },
            {
                title: 'Vendor Name',
                dataIndex: 'vendorName',
                key: 'vendorName',
                fixed: 'left',
                width: 200,
                ellipsis: true,
            },
            {
                title: 'CIN',
                dataIndex: 'companyRegistrationNumber',
                key: 'companyRegistrationNumber',
                width: 150,
                ellipsis: true
            },
            {
                title: 'Website URL',
                dataIndex: 'websiteUrl',
                key: 'websiteUrl',
                render: (text: string) => (
                    <a href={text} target="_blank" rel="noopener noreferrer">
                        {text}
                    </a>
                ),
                width: 150,
                ellipsis: true
            },
            {
                title: 'Type of Business',
                dataIndex: 'typeOfBusiness',
                key: 'typeOfBusiness',
                render: (text: string) => {
                    const businessTypes: { [key: string]: string } = {
                        privateLimited: 'Private Limited',
                        publicLimited: 'Public Limited',
                        partnership: 'Partnership',
                        soleProprietorship: 'Sole Proprietorship',
                        llp: 'LLP',
                        others: 'Others'
                    };
                    return businessTypes[text] || text;
                },
                width: 150,
                ellipsis: true
            },
            {
                title: 'GSTN',
                dataIndex: 'gstn',
                key: 'gstn',
                width: 150,
                ellipsis: true,
                align: 'center',
            },
            {
                title: 'PAN',
                dataIndex: 'pan',
                key: 'pan',
                width: 100,
                ellipsis: true,
                align: 'center',
            },

            {
                title: 'MSA Signed',
                dataIndex: 'msaSigned',
                key: 'msaSigned',
                render: (text: boolean) => {
                    return text ? 'Yes' : 'No';
                },
                width: 100,
                ellipsis: true,
                align: 'center',
            },
            {
                title: 'NDA Signed',
                dataIndex: 'ndaSigned',
                key: 'ndaSigned',
                render: (text: boolean) => {
                    return text ? 'Yes' : 'No';
                },
                width: 100,
                ellipsis: true,
                align: 'center',
            },
            {
                title: "Address",
                dataIndex: "streetAddress",
                key: "streetAddress",
                render: (text: string, record: any) => (
                    <Space direction='horizontal' className='contact_info'>
                        <div className="">
                            {text},
                            <span className="text-gray-400"> {record?.city}, {record?.state}, {record?.country} - {record?.postalCode}</span>
                        </div>
                    </Space >
                ),
                width: 150,
                ellipsis: true,
            },
            {
                title: 'Created At',
                dataIndex: 'createdAt',
                key: 'createdAt',
                render: (text: string) => {
                    return moment(text).format('DD MMM, YYYY')
                },
                width: 100,
                ellipsis: true,
                align: 'center',
            },
            {
                title: 'MSA',
                dataIndex: 'msa',
                key: 'msa',
                render: (text: string) => {
                    return <Button type="link" onClick={() => setPDF(text)}>View</Button>
                },
                width: 100,
                ellipsis: true,
                align: 'center',
                fixed: 'right',
            },
            {
                title: 'NDA',
                dataIndex: 'nda',
                key: 'nda',
                render: (text: string) => {
                    return <Button type="link" onClick={() => setPDF(text)}>View</Button>
                },
                width: 100,
                ellipsis: true,
                align: 'center',
                fixed: 'right',
            },
            {
                title: 'Skills',
                dataIndex: 'skills',
                key: 'skills',
                render: (text: any, records: any) => {
                    return <Button type="link" onClick={() => setSkills(records)}>View</Button>
                },
                width: 100,
                ellipsis: true,
                align: 'center',
                fixed: 'right',
            },

        ],
        getFormColumns: () => [
            {
                label: 'Vendor Name',
                dataIndex: 'vendorName',
                name: 'vendorName',
                type: 'text',
            },
            {
                label: 'Company Registration Number',
                dataIndex: 'companyRegistrationNumber',
                name: 'companyRegistrationNumber',
                type: 'text',
            },
            {
                label: 'Website URL',
                dataIndex: 'websiteUrl',
                name: 'websiteUrl',
                type: 'text',
            },
            {
                label: 'Type of Business',
                dataIndex: 'typeOfBusiness',
                name: 'typeOfBusiness',
                type: 'select',
                children: [
                    { name: 'Private Limited', value: 'privateLimited' },
                    { name: 'Public Limited', value: 'publicLimited' },
                    { name: 'Partnership', value: 'partnership' },
                    { name: 'Sole Proprietorship', value: 'soleProprietorship' },
                    { name: 'LLP', value: 'llp' },
                    { name: 'Others', value: 'others' }
                ]
            },
            {
                label: 'Company GSTN',
                dataIndex: 'gstn',
                name: 'gstn',
                type: 'text',
            },
            {
                label: 'PAN Number',
                dataIndex: 'pan',
                name: 'pan',
                type: 'text',
            },
            {
                label: "Street Address",
                dataIndex: "streetAddress",
                name: "streetAddress",
                type: "text",
            },
            {
                label: "City",
                dataIndex: "city",
                name: "city",
                type: "text",
            },
            {
                label: "State",
                dataIndex: "state",
                name: "state",
                type: "text",
            },
            {
                label: "Country",
                dataIndex: "country",
                name: "country",
                type: "text",
            },
            {
                label: "Postal Code",
                dataIndex: "postalCode",
                name: "postalCode",
                type: "text",
            }
        ],
        combo: []
    }

    return (<>
        <Modal
            title="Skills"
            open={skills}
            onCancel={() => setSkills(null)}
            footer={null}
            width={800}
        >
            <Table
                dataSource={skills?.skills}
                pagination={false}
                rowKey={(record: any) => record.skill}
                columns={[
                    {
                        title: 'Skill',
                        dataIndex: 'skill',
                        key: 'skill',
                    },
                    {
                        title: 'Experience From',
                        dataIndex: 'experienceFrom',
                        key: 'experienceFrom',
                        render: (text: any) => {
                            return `${text} years`;
                        }
                    },
                    {
                        title: 'Experience To',
                        dataIndex: 'experienceTo',
                        key: 'experienceTo',
                        render: (text: any) => {
                            return `${text} years`;
                        }
                    },
                    {
                        title: 'Budget From',
                        dataIndex: 'budgetFrom',
                        key: 'budgetFrom',
                        render: (text: any) => {
                            return `${text} LPM`;
                        }
                    },
                    {
                        title: 'Budget To',
                        dataIndex: 'budgetTo',
                        key: 'budgetTo',
                        render: (text: any) => {
                            return `${text} LPM`;
                        }
                    }
                ]}
            />
        </Modal>
        <Modal
            title="Agreement"
            open={pdf}
            onCancel={() => setPDF(null)}
            footer={null}
            width={800}
        >
            <iframe
                src={`${process.env.FILE_URL}/files/agreements/${pdf}`}
                width="100%"
                height="600px"
                style={{ border: 'none' }}
            ></iframe>
        </Modal>
        <MasterComponent config={config} />
    </>
    );
}

export default AgreementSigned;